import EventMetaContainer from './event_meta_container';

const EventMeta = EventMetaContainer;

export default EventMeta;
